<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container med-container px-lg-0">
        <span>Productos</span>
        <span class="line">/</span>
        <span>{{ $route.query.keywords }}</span>
      </div>
    </section>

    <section class="container med-container products-section">

      <div class="row align-items-start">

        <!-- Mobile filters -->
        <div class="col-12 col-filters-mobile">
          <div class="bg-filter-mv" v-if="showFilters == true" @click="showFilters = false"></div>
          <a class="btn-filters" @click="showFilters = !showFilters">
            <i class="fas fa-filter"></i><span>Ver filtros</span>
          </a>
        </div>

        <div class="col-lg col-filters" v-bind:class="{ 'show-filters': showFilters == true }">
          <h4 class="_title">
            <span>Filtros de Búsqueda</span>
            <a class="btn-hide" @click="showFilters = false"><i class="fas fa-chevron-left"></i></a>
          </h4>

          <b-form class="filters-container" @submit="onSubmitFilters">
            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Catálogo</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  v-model="filtersForm.categories"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-radio :value="null">Todos</b-form-radio>
                  <b-form-radio :value="c.id" v-for="(c,cInx) in $root.categories" :key="'cInx'+cInx">{{ c.name }}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <!-- <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Subcategoria</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.subcategories"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="subc.id" v-for="(subc,indx) in subcategoriesOpcs" :key="'subca'+indx">{{subc.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div> -->

            <!-- <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Precio</a>

              <div class="box-filters-group">
                <b-form-select class="c-filter-select" v-model="filtersForm.price">
                  <b-form-select-option :value="null">Cualquiera</b-form-select-option>
                  <b-form-select-option :value="800">$1,000 o más</b-form-select-option>
                  <b-form-select-option :value="1499">$3,000 o más</b-form-select-option>
                  <b-form-select-option :value="999999999999999999">$4,500 o más</b-form-select-option>
                </b-form-select>
              </div>
            </div> -->
          </b-form>
        </div>
        <!--  -->

        <!-- Resultados en columnas -->
        <div class="col-lg col-products">
          <div class="row sample-products-wrapper" v-if="!isLoading">
            <div class="col-12 col-s-title px-lg-2 mb-2">
              <h2 class="title-s1">
                <span style="font-size:80%">
                  <span class="f-w-400">Buscar: </span>{{ $route.query.keywords }}
                </span>
              </h2>
            </div>

            <div class="col-md-6 col-xl-4 sample-product shad-prod" v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <a class="outlined-box">
                <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                <div class="box-image">
                  <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                    <img src="public/images/pages/products/product.png" >
                  </div>
                </div>

                <div class="box-shot-descr">
                  <h6 class="brand">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>
                  <div class="b-type" v-if="product.stock">
                    <div class="type s2">{{ product.stock }} DISPONIBLES</div>
                  </div>
                  <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                  <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                  <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} MXN</h6>
                </div>

                <cart-component :product="product"></cart-component>
              </a>
            </div>

            <!-- <div class="col-12 col-pagination">
              <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination.total" use-router></b-pagination-nav>
            </div> -->
          </div>

          <div class="row">
            <div class="col-12 text-center py-5" v-if="!products.length && !isLoading">
              <h5>No se encontraron resultados</h5>
            </div>

            <div class="col-12" v-if="isLoading">
              <LoadingComponent></LoadingComponent>
            </div>
          </div>
        </div>
        <!--  -->

      </div>

    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      showFilters: false,

      filtersForm: {
        keywords: null,
        categories: null,
        price: null,
      },

      products: [
        // {
        //   "id": 1,
        //   "sku": "63423",
        //   "name": "CORONA T-358 PLATA",
        //   "price": "75.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
      ],

      category_id:null,
      brandsOpcs:[
        // { id: 1, name: 'Accesorios' },
        // { id: 2, name: 'Baby Shower' },
        // { id: 3, name: 'Bautizo' },
        // { id: 4, name: 'Boda' },
        // { id: 5, name: 'Broches' },
        // { id: 6, name: 'Confirmación' },
        // { id: 7, name: 'XXXXX' },
        // { id: 8, name: 'Graduación' },
        // { id: 9, name: 'Rosarios' },
      ],

      // == Pagination ==
      pagination:{
        currentpage: 1,
        total: 1,
        total_products: 16,
        number: 10
      },
      // == ==
    }
  },

  watch: {
    '$route.query.keywords':function(){
      this.isLoading = true;
      this.getSearch();
    },

    // "$route.params.id" : function(v){
    //   this.category_id = this.$root._getURLID(this.$route.params.id);
    //   if(this.category_id){
    //     this.products=[];
    //     this.getSearch(this.category_id);
    //   }
    // },

    "filtersForm.categories" : function(v){
      this.getSearch(v);
    },

    // "filtersForm.price" : function(v){
    //   this.getSearch(this.category_id);
    // },
  },

  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },

    onSubmitFilters(evt) {
      evt.preventDefault();
    },

    getSearch: function(){
      this.isLoading = true;
      this.filtersForm.keywords = this.$route.query.keywords;

      axios.post(tools.url('/api/products/search'),this.filtersForm).then((response) =>{
        this.products = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  mounted(){
    if(this.$route.query.keywords){
      this.getSearch();
    }
  },
}
</script>
